<template>
  <a-modal
    :title="`分配岗位 - ${user.name || ''}`"
    :visible="visible"
    :footer="null"
    width="720px"
    @cancel="close"
  >
    <!-- 添加岗位 -->
    <div class="add-bar">
      <a-select
        v-model="selectedPositionId"
        show-search
        allow-clear
        option-filter-prop="children"
        placeholder="选择岗位"
        style="width: 260px"
      >
        <a-select-option v-for="item in selectablePositions" :key="item.id" :value="item.id">
          {{ item.name }}（{{ item.code }}）
        </a-select-option>
      </a-select>
      <a-checkbox :checked="isPrimary" @change="(e) => (isPrimary = e.target.checked)">设为主岗位</a-checkbox>
      <a-date-picker
        v-model="expireDate"
        placeholder="失效时间（不选=永久）"
        style="width: 180px"
        value-format="YYYY-MM-DD"
      />
      <a-button type="primary" :disabled="!selectedPositionId" :loading="assigning" @click="assign">
        添加
      </a-button>
    </div>
    <div class="add-tip">主岗位分配会自动回收该用户旧主岗位的角色与数据权限</div>

    <a-divider style="margin: 12px 0" />

    <a-table
      bordered
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :dataSource="positions"
      :pagination="false"
    >
      <template slot="primaryCol" slot-scope="text">
        <a-tag v-if="text" color="blue">主岗位</a-tag>
        <a-tag v-else>兼职</a-tag>
      </template>
      <template slot="statusCol" slot-scope="text">
        {{ statusName(text) }}
      </template>
      <template slot="expireCol" slot-scope="text">
        {{ text || "永久" }}
      </template>
      <template slot="actionCol" slot-scope="text, record">
        <a class="danger-link" @click="removePosition(record)">移除</a>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { fetchUserPositions, fetchPositionList, assignUserPosition, removeUserPosition } from "@/api/setting/auth";

export default {
  name: "user-position-modal",

  props: {
    visible: { type: Boolean, default: false },
    // 用户对象（需要uuid、name）
    user: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      assigning: false,
      positions: [],
      allPositions: [],
      selectedPositionId: undefined,
      isPrimary: false,
      expireDate: null,
      columns: [
        { title: "岗位名称", dataIndex: "positionName", width: 160 },
        { title: "岗位编码", dataIndex: "positionCode", width: 130 },
        { title: "部门", dataIndex: "deptName", width: 160 },
        { title: "主/兼", dataIndex: "isPrimary", width: 80, align: "center", scopedSlots: { customRender: "primaryCol" } },
        { title: "状态", dataIndex: "status", width: 80, align: "center", scopedSlots: { customRender: "statusCol" } },
        { title: "失效时间", dataIndex: "expireAt", width: 140, scopedSlots: { customRender: "expireCol" } },
        { title: "操作", width: 70, align: "center", scopedSlots: { customRender: "actionCol" } },
      ],
    };
  },

  computed: {
    // 过滤掉已持有的岗位
    selectablePositions() {
      const heldIds = this.positions.map((p) => p.positionId);
      return this.allPositions.filter((p) => !heldIds.includes(p.id));
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.selectedPositionId = undefined;
        this.isPrimary = false;
        this.expireDate = null;
        this.load();
        this.loadAllPositions();
      }
    },
  },

  methods: {
    statusName(status) {
      const map = { active: "生效中", pending: "待生效", expired: "已过期" };
      return map[status] || status;
    },
    load() {
      if (!this.user.uuid) {
        return;
      }
      this.loading = true;
      fetchUserPositions(this.user.uuid)
        .then((res) => {
          this.positions = Array.isArray(res) ? res : [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadAllPositions() {
      if (this.allPositions.length > 0) {
        return;
      }
      fetchPositionList()
        .then((res) => {
          this.allPositions = Array.isArray(res) ? res : [];
        })
        .catch(() => {});
    },
    assign() {
      this.assigning = true;
      assignUserPosition({
        userId: this.user.uuid,
        positionId: this.selectedPositionId,
        isPrimary: this.isPrimary,
        expireAt: this.expireDate || null,
      })
        .then(() => {
          this.$message.success("分配成功");
          this.selectedPositionId = undefined;
          this.isPrimary = false;
          this.expireDate = null;
          this.load();
        })
        .catch(() => {})
        .finally(() => {
          this.assigning = false;
        });
    },
    removePosition(record) {
      const that = this;
      this.$confirm({
        title: `确认移除岗位「${record.positionName}」吗？`,
        content: "移除后该用户将失去此岗位绑定的角色与数据权限。",
        onOk() {
          return removeUserPosition({ userId: that.user.uuid, positionId: record.positionId }).then(() => {
            that.$message.success("移除成功");
            that.load();
          });
        },
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.add-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.add-tip {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.danger-link {
  color: #f5222d;
}
</style>
